import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyStayUpgradeBenefitsModal from './LandingPageLoyaltyStayUpgradeBenefitsModal'
import BodyText from 'LuxKit/Typography/BodyText'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyStayUpgrade(props: Props) {
  const { layout, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const isInfinite = useAppSelector(getLoyaltyIsInfiniteAccountTier)

  const heading = isInfinite
    ? intl.formatMessage({
        id: 'o8mDr0BpCXuXwYSzqWHw',
        defaultMessage: 'Infinite room & package upgrades',
        description: 'Heading for the room and package upgrade benefit tile shown to Infinite tier members',
      })
    : intl.formatMessage({
        defaultMessage: 'Free room or package upgrades',
        id: '-jf0-fEIahxd0huyr3Zg',
        description: 'Heading for loyalty stay upgrade benefit tile component',
      })

  const infiniteSubtitle = (
    <BodyText variant="small">
      {intl.formatMessage({
        id: 'oxf3FGHL2rKnZ-RfCHPp',
        defaultMessage: 'For select hotel bookings',
        description: 'Subtitle for the Infinite room and package upgrade benefit tile on the loyalty account page',
      })}
    </BodyText>
  )
  const image = useMemo<App.Image>(() => ({
    id: 'wfzka1j5ru5d5e7hc9u',
    title: intl.formatMessage({
      id: '1BIZ34jMRV4vOcu7M2Yj',
      defaultMessage: 'Free room upgrades',
      description: 'Alternative text fallback for the room upgrade loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyStayUpgradeBenefitsModal image={image} />)
  }, [image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="hotel_upgrade"
    heading={heading}
    subtitle={isInfinite ? infiniteSubtitle : benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyStayUpgrade
